const paths = {
  login: "/login",
  forgotPassword: "/forgot-password",
  passwordReset: "/password-reset",
  logout: "/logout",
  perks: "/perks",
  surveys: "/surveys",
  basePath: "/app",
  companies: "/companies",
  sentiment: "/sentiment",
  messages: "/communication",
  users: "/users",
  user: "/users/:email",
  company: "/companies/:id",
  perk: "/perks/:id",
  message: "/communication/:id",
  companyMessages: "/companies/:id/messages",
  createPortfolio: "/create-portfolio",
  pooHistory: "/poo-history",
  uploadFile: "/upload-file",
  redemptions: "/users/:id/redemptions",
  supportTickets: "/support-tickets",
  supportTicket: "/support-tickets/:id",
}

export const getFullPath = (path: string): string => {
  return `${paths.basePath}${path}`
}

export default paths
